import { Stack } from '@mui/material';
import { Card, CardContent } from './Card';
import { CircularProgress } from './CircularProgress';

export const LoadingCard = () => {
  return (
    <Card>
      <CardContent>
        <Stack alignItems='center' padding={8}>
          <CircularProgress />
        </Stack>
      </CardContent>
    </Card>
  );
};
